import { render, staticRenderFns } from "./AssetDetailTab.vue?vue&type=template&id=ed89b522"
import script from "./AssetDetailTab.js?vue&type=script&lang=js&external"
export * from "./AssetDetailTab.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports